import { useMe } from '@/context/me/me.context';
import useQuestionnaireData from '@/hooks/use-questionnaire-data';
import { useGetCommPreferences } from '@/queries/comm-preferences.queries';
import { useGetMembershipStatus } from '@/queries/membership.queries';
import { useGetQuestionnaire } from '@/queries/questionnaire.queries';
import { useSearchParams } from 'react-router-dom';

export default function useAccountController() {
  const { data: userData } = useMe();
  const name = userData?.profile?.name as string;
  const email = userData?.account.credential as string;
  const membershipId = userData?.membership.id as string;
  const cardLast4Digits = userData?.membership?.paymentMethod?.last4 ?? '';
  const paymentFunding = userData?.membership?.paymentMethod?.funding ?? '';

  const [params] = useSearchParams();
  const defaultTab = params.get('tab') === 'risk' ? 1 : 0;

  const { data: userQuestionnaire } = useGetQuestionnaire();
  const { questionnaireStatus, iDontKnowAnswers, answeredQuestions, assessmentProgress } =
    useQuestionnaireData(userQuestionnaire);

  const { data: membershipData } = useGetMembershipStatus(membershipId);
  const type = membershipData?.type as string;
  const cancelAtPeriodEnd = membershipData?.cancelAtPeriodEnd as boolean;
  const price = membershipData?.price?.amount as number;
  const usdPrice = price / 100;
  const date = new Date(membershipData?.renewalDate as string);

  let renewalDate = '';

  if (membershipData?.renewalDate) {
    const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
    renewalDate = new Intl.DateTimeFormat('en-US', options).format(date);
  }

  const { data: communicationPreferences } = useGetCommPreferences();

  const notificationsPreferences = communicationPreferences?.preferences || [];

  return {
    name,
    email,
    cardLast4Digits,
    assessmentProgress,
    defaultTab,
    type,
    cancelAtPeriodEnd,
    usdPrice,
    renewalDate,
    questionnaireStatus,
    iDontKnowAnswers,
    answeredQuestions,
    notificationsPreferences,
    paymentFunding,
  };
}
